// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error[data-v-1b3d83cc]{border:1px solid var(--uiRedDarker)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
